interface GetCountdownSecondsParams {
  targetTimestamp: Maybe<string>
  now: number
}

/**
 * Whole seconds remaining until `targetTimestamp`, relative to `now` (both in ms epoch / ISO).
 * Rounds up so a partial second still reads as counting down; returns 0 once the time has passed or
 * when there is no timestamp.
 */
export const getCountdownSeconds = ({ targetTimestamp, now }: GetCountdownSecondsParams): number => {
  if (!targetTimestamp) {
    return 0
  }

  const remainingMs = Date.parse(targetTimestamp) - now

  if (remainingMs <= 0) {
    return 0
  }

  return Math.ceil(remainingMs / 1000)
}
